import React from "react";

function RapidChatbot() {
  return (
    <div className="optimization-bg">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-10 col-md-12 col-sm-12 mt-5 mb-5">
            <h1 className="Text-heading text-center" data-aos="fade-up">
              Chatbot Solutions Dubai
            </h1>
            <p className="text-detail text-center " data-aos="fade-up">
              Contact the top chatbot development firm in Dubai to empower your
              organisation with a bespoke chatbot that works in tandem with your
              needs.
            </p>
            <div className="text-center" data-aos="fade-up">
              <button className="btn btn-experts p-3">Schedule A Call</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RapidChatbot;
